import React from 'react';

import { StyledLink } from './EmbeddedEntryLinkStyles';

/**
 * Render embedded link in rich text
 *
 * @param {Boolean} isInternal
 * @param {Boolean} noFollow
 * @param {String} title
 * @param {String} url
 *
 * @returns {React.ReactElement}
 */
function EmbeddedEntryLink({ isInternal, title, url, noFollow }) {
  return (
    <span>
      <StyledLink url={url} isInternal={isInternal} noFollow={noFollow} underline="always">
        {title}
      </StyledLink>
    </span>
  );
}

export default EmbeddedEntryLink;
